import { render, staticRenderFns } from "./fictitiousCourse.vue?vue&type=template&id=4cd3bfc8&scoped=true"
import script from "./fictitiousCourse.vue?vue&type=script&lang=js"
export * from "./fictitiousCourse.vue?vue&type=script&lang=js"
import style0 from "./fictitiousCourse.vue?vue&type=style&index=0&id=4cd3bfc8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd3bfc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd3bfc8')) {
      api.createRecord('4cd3bfc8', component.options)
    } else {
      api.reload('4cd3bfc8', component.options)
    }
    module.hot.accept("./fictitiousCourse.vue?vue&type=template&id=4cd3bfc8&scoped=true", function () {
      api.rerender('4cd3bfc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collegeEdition/fictitiousCourse.vue"
export default component.exports